/* eslint-disable no-continue */
/* eslint-disable no-plusplus */

import React, { useEffect, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useSelector } from "react-redux";

import { Helmet } from "react-helmet";
import CompleteBox from "../../components/CompleteBox";
import PageFooter from "../../components/PageFooter";
import PartnerLink from "../../components/PartnerLink";
import Section from "../../components/Section";
import { CardProps, InputTypes, ItemTypeProps, SectionProps, StateProps } from "../../store";
import * as S from "./styles";

const Preview = () => {
  const { cards } = useSelector((state: StateProps) => state);
  const { formEtcs } = useSelector((state: StateProps) => state);
  const [sections, setSections] = useState<SectionProps[]>([]);
  const methods = useForm();
  const [closedCardIds, setClosedCardIds] = useState<string[]>([]);

  useEffect(() => {
    setSection();
  }, []);

  const setSection = () => {
    const Section = [] as SectionProps[];
    let addableCards = [] as CardProps[];

    cards.forEach((card) => {
      if (card.inputType === InputTypes.SECTION || card.inputType === InputTypes.ADDABLE_SECTION) {

        // 이전 section 이 addable section 이었을 경우
        if(addableCards.length > 0) {

          const {teamNumber} = Section[Section.length - 1];
          if(teamNumber !== undefined) {
            for (let i = 0; i < teamNumber; i++) {
              for (let j = 0; j < addableCards.length / teamNumber; j++) {
                Section[Section.length - 1].cards.push(addableCards[j * teamNumber + i]);
              }
            }
            addableCards = [];
          }
        }

        let length = card.lengthMin;

        if(card.inputType === InputTypes.ADDABLE_SECTION && (card.lengthMin === undefined || card.lengthMin === null || card.lengthMin === 0)) {
          length = 1;
        }

        Section.push({
          formSectionId: card.id,
          sectionTitle: card.cardTitle,
          teamNumber: length,
          cards: [],
          isTitle: card.id.split("-")[1] === "titleSection",
        });
      } else {
        const lastSection = Section[Section.length - 1];
        if (lastSection) {

          const isAddable = lastSection.teamNumber !== undefined && lastSection.teamNumber > 1;

          if(isAddable) {
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            for(let i = 0; i < lastSection.teamNumber!; i++) {

              setClosedCardIds([...closedCardIds, card.id]);

              if(card.inputType === InputTypes.CHECKBOX || card.inputType === InputTypes.RADIO || card.inputType === InputTypes.SELECT) {

                const contents = card.contents as ItemTypeProps[];
                const newContents = [] as ItemTypeProps[];

                contents.forEach((content) => {
                  newContents.push({
                    id: `${content.id}=${i}`,
                    text: content.text,
                    isEtc: content.isEtc,
                  });
                });

                addableCards.push({
                  id: card.id,
                  cardTitle: card.cardTitle,
                  inputType: card.inputType,
                  subText: card.subText,
                  placeholder: card.placeholder,
                  contents: newContents,
                  isFocused: false,
                  isRequired: card.isRequired,
                  lengthMin: card.lengthMin,
                });
              } else {
                addableCards.push({
                  id: card.id,
                  cardTitle: card.cardTitle,
                  inputType: card.inputType,
                  subText: card.subText,
                  placeholder: card.placeholder,
                  contents: card.contents,
                  isFocused: false,
                  isRequired: card.isRequired,
                  lengthMin: card.lengthMin,
                });
              }
            }
          } else {
            lastSection.cards.push(card);
          }
        }
      }
    });

    // 마지막 section 이 addable section 이었을 경우
    if(addableCards.length > 0) {
      const {teamNumber} = Section[Section.length - 1];
      if(teamNumber !== undefined) {
        for (let i = 0; i < addableCards.length / teamNumber; i++) {
          for (let j = 0; j < teamNumber; j++) {
            Section[Section.length - 1].cards.push(addableCards[j * (addableCards.length / teamNumber) + i]);
          }
        }
        addableCards = [];
      }
    }

    setSections(Section);

    console.log('section', Section);
  };

  return (
    <S.PreviewContainer>
      <span
        style={{
          width: "100%",
          color: "white",
          textAlign: "center",
          fontSize: 14,
          position: "fixed",
          padding: 2,
          backgroundColor: "#0B24FB",
          zIndex: 100,
        }}
      >
        *미리보기 화면입니다.
      </span>
      <div style={{ padding: "10px" }} />
      <FormProvider {...methods}>
        <Helmet>
          <title>{sections[0]?.cards[0]?.cardTitle || "한달살러폼"}</title>
        </Helmet>
        <PartnerLink link={formEtcs.partnerLink} image={formEtcs.partnerImage} />
        {sections.map((section) => (
          <Section section={section} closedCardIds={closedCardIds} setClosedCardIds={setClosedCardIds} clickSubmit={false} email="프리뷰 사용자"/>
        ))}
        <S.PreviewSubmitSection>
          <S.SubmitButton type="submit">제출하기</S.SubmitButton>
        </S.PreviewSubmitSection>
        <PageFooter partnerName={formEtcs.partnerName} />
      </FormProvider>
      <S.Complete>
        <S.CompleteTitle>신청완료 후 확인화면</S.CompleteTitle>
      </S.Complete>
      <div>
        <PartnerLink link={formEtcs.partnerLink} image={formEtcs.partnerImage} />
        <CompleteBox
          completeTitle={formEtcs.completeTitle}
          completeText={formEtcs.completeText || ""}
        />
        <PageFooter partnerName={formEtcs.partnerName} />
      </div>
    </S.PreviewContainer>
  );
};

export default Preview;
